export const friendship = `
    id
    primaryUserId
    primaryUser {
      id
      name
      email
      profilePicture
      username
      birthDate
    }
    secondaryUser {
      id
      name
      email
      profilePicture
      username
      birthDate
    }
    secondaryUserId
    friendshipStatus
    createdAt
    updatedAt
`;
export const getFriendshipQuery = /* GraphQL */ `
  query GetFriendship($id: ID!) {
    getFriendship(id: $id) {
      ${friendship}
    }
  }
`;
